import React from 'react';
import { DataTable, ColumnDef } from '@/components/data-display/DataTable';
import { MOCK_INTEGRATION_LOGS } from '@/mocks/database';
import { IntegrationLog } from '@/types/domain';
import { formatDate } from '@/lib/utils';
import { Badge } from '@/components/ui/Badge';

export const IntegrationLogsPage: React.FC = () => {
  const columns: ColumnDef<IntegrationLog>[] = [
    { header: 'Txn ID', accessorKey: 'transactionId', cell: (row) => <span className="font-mono text-xs">{row.transactionId}</span> },
    { header: 'Flow', cell: (row) => `${row.sourceSystem} → ${row.targetSystem}` },
    { header: 'BAPI / Operation', accessorKey: 'operationName', cell: (row) => <span className="font-mono font-bold text-sap">{row.operationName}</span> },
    { header: 'Payload Summary', accessorKey: 'payloadSummary' },
    { header: 'Latency', accessorKey: 'durationMs', cell: (row) => `${row.durationMs} ms` },
    { header: 'Status', accessorKey: 'responseStatus', cell: (row) => <Badge variant="success">{row.responseStatus}</Badge> },
    { header: 'Timestamp', accessorKey: 'timestamp', cell: (row) => formatDate(row.timestamp) },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-foreground">SAP & Microservices Integration Telemetry</h1>
        <p className="text-xs text-muted-foreground mt-0.5">
          Real-time integration monitor tracking BAPI calls, latency metrics, and API payload sync events.
        </p>
      </div>

      <DataTable data={MOCK_INTEGRATION_LOGS} columns={columns} searchPlaceholder="Search integration logs..." />
    </div>
  );
};
